import { useCallback, RefObject } from "react";
import { AgGridReact } from "ag-grid-react";
import useUiuxStore from "src/store/useUiuxStore";
import { focusToCell } from "src/utils/grid/GridHandlerContent";
import { MST4030_R01DetailDto } from "../Dto_MST4030_R01";

interface UseMST4030_R01ModalProps {
	updateMST4030_R01DetailList: (index: number, data: MST4030_R01DetailDto) => void;
	gridRef: RefObject<AgGridReact<MST4030_R01DetailDto> | null>;
}

export function useMST4030_R01Modal({
	updateMST4030_R01DetailList,
	gridRef,
}: UseMST4030_R01ModalProps) {
	const { setCodeSearchModalProps } = useUiuxStore();

	const handlePopupClose = useCallback(() => {
		if (gridRef.current?.api) {
			gridRef.current.api.stopEditing();
		}
	}, [gridRef]);

	const settingCodeSearchModalProps = useCallback(
		(
			category: string,
			search: string,
			isInfo: boolean,
			handleFoucsId: string,
			rowData: MST4030_R01DetailDto,
			valueIndex: number,
			originalData?: MST4030_R01DetailDto,
		) => {
			const baseData = originalData ?? rowData;
			const wrapperOptionMap: Record<string, { size: string; width: number; overlay: boolean }> = {
				inspectEmpno: { size: "md", width: 50, overlay: true },
			};

			setCodeSearchModalProps({
				category,
				search,
				formName: "MST4030_R01",
				isInfo,
				handleFoucsId,
				wrapperOption: wrapperOptionMap[handleFoucsId] ?? { size: "md", width: 50, overlay: true },
				onClear: () => {
					updateMST4030_R01DetailList(valueIndex, {
						...baseData,
						inspectEmpno: "",
						inspectEmpNm: "",
						isModified: true,
					});
					handlePopupClose();
				},
				onConfirm: (data: any) => {
					updateMST4030_R01DetailList(valueIndex, {
						...rowData,
						inspectEmpno: data.empNo || "",
						inspectEmpNm: data.empNm || "",
						isModified: true,
					});

					setTimeout(() => {
						if (!gridRef.current) return;
						focusToCell(gridRef, valueIndex, "remark");
					}, 100);
				},
			});
		},
		[setCodeSearchModalProps, updateMST4030_R01DetailList, gridRef, handlePopupClose],
	);

	return { settingCodeSearchModalProps, handlePopupClose };
}
